export class ContractNote {
  ContractId: number;
  ContractNoteId: number;
  note: string;
  CreatedDate: Date;
  CreatedBy: string;

}
